const _chainId = "0x" + process.env.REACT_APP_ETH_CHAIN_ID.toString(16);

const activate = async () => {
  const { ethereum } = window;

  const provider = _getProvider();
  if (!provider) {
    window.open(process.env.REACT_APP_METAMASK_DEEPLINK);
    throw new Error("Please install corresponding wallet extension");
  }

  if (ethereum !== provider) {
    ethereum.setSelectedProvider(provider);
  }

  await provider.send("wallet_switchEthereumChain", [{ chainId: _chainId }]);

  if (!provider.isConnected()) {
    provider.on("connect", (info) => {
      _handleChainUpdate(info.chainId);
    });
  }

  await provider.request({ method: "eth_requestAccounts" }); //some kind of activation request

  return provider;
};

const _handleChainUpdate = (chainId) => {
  if (chainId === _chainId) return;

  window.confirm("Only Görli chain supported, should switch from your wallet");
};

const getAddress = async () => {
  const provider = _getProvider();
  if (!provider) {
    throw new Error("Please install corresponding wallet extension");
  }

  const accounts = await provider.request({ method: "eth_requestAccounts" });
  return accounts[0];
};

const subscribeOnEvents = (onAccountChanged) => {
  const { ethereum } = window;

  const accountsChanged = "accountsChanged";
  ethereum.removeAllListeners(accountsChanged);
  ethereum.on(accountsChanged, (accounts) => {
    console.log(accounts);
    onAccountChanged(accounts[0]);
  });

  const chainChanged = "chainChanged";
  ethereum.removeAllListeners(chainChanged);
  ethereum.on(chainChanged, (chainId) => {
    _handleChainUpdate(chainId);
  });
};

const _getProvider = () => {
  const { ethereum } = window;
  if (!ethereum) return null;

  const { providers } = ethereum;

  if (providers?.length) {
    return providers.find(({ isMetaMask }) => isMetaMask);
  } else if (ethereum.isMetaMask) {
    return ethereum;
  } else {
    return null;
  }
};

export { activate, subscribeOnEvents, getAddress };
